// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"45d080bc","82":"d2c31ae8","247":"b251aff2","312":"65b2c4ec","422":"83dd26c8","424":"7d32130a","551":"962b5340","627":"1cde9608","834":"e108f1e2","867":"647e591d","923":"afab4d40","938":"2ece0924","971":"a5f0a15d"}[chunkId] + ".chunk.js";
};